import { type FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Image } from '@chakra-ui/react';
import {
  Button,
  Typography,
  View,
  YStack,
} from '@shinetools/sunshine-universal';

import fadedFlower from 'assets/brand/faded-flower.png';
import SunshineModal from 'components/_core/SunshineModal';

import { modalMinHeight } from '../utils/constant';

type ChallengeRequestExpiredProps = {
  onClose: () => void;
};

const ChallengeRequestExpired: FC<ChallengeRequestExpiredProps> = ({
  onClose,
}) => {
  return (
    <>
      <SunshineModal.Body minHeight={modalMinHeight}>
        <YStack gap={24} padding="$space.16">
          <YStack alignItems="center">
            <Image
              src={fadedFlower}
              style={{
                marginBottom: 24,
                opacity: 1,
                width: '30%',
              }}
            />
          </YStack>

          <Typography.Header>
            <FormattedMessage id="authentication.challenge.expired.title" />
          </Typography.Header>
          <Typography.Text>
            <FormattedMessage id="authentication.challenge.expired.description" />
          </Typography.Text>
        </YStack>
      </SunshineModal.Body>
      <SunshineModal.Footer flexDirection="row" gap={16}>
        <View marginLeft="75%">
          <Button onPress={onClose}>
            <FormattedMessage id="authentication.finish" />
          </Button>
        </View>
      </SunshineModal.Footer>
    </>
  );
};

export default ChallengeRequestExpired;
